import {
    Avatar,
    Button,
    Col,
    DatePicker,
    Flex,
    Form,
    Input,
    InputNumber,
    Modal,
    Row,
    Select,
    TimePicker,
    Typography,
  } from "antd";
  
  import React, { useEffect } from "react";
  import { CustomTitle } from "../../../../../common/customTitle";
  import { useState } from "react";
  import { useDispatch, useSelector } from "react-redux";
  import { useNavigate } from "react-router-dom";
  import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
  import { useTranslation } from "react-i18next";
  import {
    dateObjToDispViewDate,
    sanitizeDataTypeClientSide,
    timeObjToDispViewTimeWithSuffix,
  } from "../../../../../../utils/utils";
  import {
    getCustomerDetailsAction,
    getServiceProviderCustomersAction,
    searchCustomersAction,
  } from "../../../../../../redux/services/service-provider-customers/serviceProviderCustomersServices";
  import { appConstConfig } from "../../../../../../constants/config/appConstConfig";
  import Actions from "../../../../../../redux/actions";
  import useDebounce from "../../../../../../hooks/useDebounce";
  import { appAssetsConfig } from "../../../../../../constants/config/appAssetsConfig";
  import { colors } from "../../../../../../constants/colors";
  import {
    getStaffAction,
    getStaffSelectListAction,
  } from "../../../../../../redux/services/staff/staffServices";
  import { getServicesSelectList } from "../../../../../../redux/services/services/servicesApis";
  import { getServicesSelectListAction } from "../../../../../../redux/services/services/servicesServices";
  import dayjs from "dayjs";
  import { createServiceInfoAction, createServiceProviderAppointmentAction, updateServiceInfoAction } from "../../../../../../redux/services/service-provider-appointments/serviceProviderAppointmentsServices";
import { allowCharactersOnlyForDecimalNumbers } from "../../../../../../utils/appKeyStrokeLimitingUtils";
  
  const ServiceInfoFormDialog = ({ open, onClose, selectedServiceInfoDetails }) => {
    /* i18n dependencies */
    const { t } = useTranslation();
    /* i18n dependencies */
  
    /* For navigating between pages */
    const navigate = useNavigate();
    /* For navigating between pages */
  
    /* dispatch an action */
    const dispatch = useDispatch();
    /* dispatch an action */
  
    /* login details */
    const { loginDetails } = useSelector((state) => state.auth);
    /* login details */
  
    /* form dependencies */
    const [form] = Form.useForm();
    const bookingFor = Form.useWatch("booking_for", { form, preserve: true });
    const orderType = Form.useWatch("order_type", { form, preserve: true });
    const initialValues = {
      appointment_date: null,
      appointment_time: "",
    };
    const [pagination, setPagination] = useState({
      pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
      pageSize: 500,
    });
    /* form dependencies */
  
    /* loading dependencies */
    const [loading, setLoading] = useState(false);
    const [selectListLoader, setSelectListLoader] = useState(false);
    /* loading dependencies */
  
    /* id dependencies */
    let timeout = null;
    const { selectedAppointmentDate } = useSelector(
      (state) => state.serviceProviderAppointments
    );
  
    const { selectedServiceProviderCustomerDetails } = useSelector(
      (state) => state.serviceProviderCustomers
    );
    /* id dependencies */
  
    /* select list dependencies */
    const [
      serviceProviderCustomersSelectList,
      setServiceProviderCustomersSelectList,
    ] = useState([]);
    const [
      selectedServiceProviderCustomerObj,
      setSelectedServiceProviderCustomerObj,
    ] = useState(null);
    const [selectedServiceObj, setSelectedServiceObj] = useState(null);
    const [selectedServiceProviderObj, setSelectedServiceProviderObj] =
      useState(null);
    const [selectedOrder, setSelectedOrder] = useState("");
    const { staffSelectList } = useSelector((state) => state.staff);
    const { servicesSelectList } = useSelector((state) => state.services);
    const { selectedAppointmentsInfoId } = useSelector(
        (state) => state.serviceProviderAppointments
      );
    /* select list dependencies */
  
    /* initial dependencies */
    useEffect(() => {
      form.setFieldsValue({
        appointment_date: selectedAppointmentDate?.appointmentDate || null,
        appointment_time: selectedAppointmentDate?.appointmentTime || "",
      });
    }, [selectedAppointmentDate]);
    /* initial dependencies */
  
    const selectListApiCalls = () => {

      // service provider / staff select list
      const dataToBeSentForStaffSelectList = {page: pagination?.pageNo,limit: pagination?.pageSize}
      dispatch(getStaffSelectListAction(dataToBeSentForStaffSelectList, setLoading));
  
      // services select list
      const dataToBeSentForServicesSelectList = {page: 1,limit: 500}
    dispatch(getServicesSelectListAction(dataToBeSentForServicesSelectList, setLoading));
    };
  
    useEffect(() => {
      selectListApiCalls();
    }, []);
  
    /* on service provider changed */
    const onServiceProviderChanged = (value) => {
      const selectedServiceProviderObject = staffSelectList?.find(
        (element) => element._id === value
      );
      setSelectedServiceProviderObj(selectedServiceProviderObject);
    };
    /* on service provider changed */

  
    /* dialog close dependencies */
    const handleDialogClose = () => {
      form.resetFields();
      onClose();
      setServiceProviderCustomersSelectList([]);
      setSelectedServiceProviderCustomerObj(null);
    };
    /* dialog close dependencies */


    useEffect(() => {
        if (selectedServiceInfoDetails) {
          form.setFieldsValue({
            service_name: selectedServiceInfoDetails?.service_name,
            service_price: selectedServiceInfoDetails?.service_price,
            service_provider_id : selectedServiceInfoDetails?.service_provider_id?._id
          });
        }
      }, [form, selectedServiceInfoDetails]);
  
    /* on submit */
    const onSubmit = (values) => {
      const {service_price, ...rest} = values;

      const dataToBeSent = {
        ...rest,
        service_price:Number(values?.service_price) || 0,
        selectedAppointmentsInfoId
      };
      
      if(selectedServiceInfoDetails){
        dataToBeSent.extra_service_id = selectedServiceInfoDetails?._id;
        dispatch(updateServiceInfoAction(dataToBeSent, navigate, setLoading)).then(() => {
            handleDialogClose();
          });
      }
      else {
          dispatch(createServiceInfoAction(dataToBeSent, navigate, setLoading)).then(() => {
            handleDialogClose();
          });
      }
    };
    /* on submit */
  
    const appointmentType = [{ value: "IN_PERSON", label: "In Person" }];
  
    // loginDetails?.organization_id?.current_plan_id?.code === "Elite" &&
    loginDetails?.organization_id?.current_plan_id?.code === "ELITE-PREMIUM" &&
      appointmentType.push({ value: "VIDEO_CALL", label: "Video Call" });
  
    return (
      <Modal
        open={open}
        onCancel={handleDialogClose}
        footer={false}
        confirmLoading={loading}
        width={800}
      >
        <Flex vertical gap="3rem" align="center" justify="center">
          <CustomTitle textDecoration="underline" justifyContent="center">
            {`${selectedServiceInfoDetails?._id ? t("Modules.Services.ServicesForm.editService") : t("Modules.Services.ServicesForm.addService")}`}
          </CustomTitle>
        </Flex>
        <Form
          style={{ marginTop: 20 }}
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          onFinish={onSubmit}
          initialValues={initialValues}
        >
          <Row gutter={[16, 16]}>
  
              <Col span={12}>

              <Form.Item
                    label={
                      <RequiredLabel
                        text={t("Modules.Appointments.service")}
                        required={true}
                      />
                    }
                    name="service_name"
                    rules={[
                      {
                        required: true,
                        message: t(
                          "Modules.Appointments.pleaseEnterService"
                        ),
                      },
                      {
                        whitespace: true,
                        message: t(
                          "Modules.Appointments.pleaseEnterService"
                        ),
                      },
                    ]}
                    normalize={(value) => sanitizeDataTypeClientSide(value)}
                  >
                    <Input
                      placeholder={t(
                        "Modules.Appointments.enterService"
                      )}
                    />
                  </Form.Item>
              </Col>

            {(
              <Col span={12}>
                <Form.Item
                  name="service_provider_id"
                  label={
                    <RequiredLabel
                      text={t("Modules.Appointments.serviceProvider")}
                      required={true}
                    />
                  }
                  rules={[
                    {
                      required: true,
                      message: t(
                        "Modules.Appointments.pleaseSelectServiceProvider"
                      ),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    loading={selectListLoader}
                    options={staffSelectList}
                    placeholder={t("Modules.Appointments.selectServiceProvider")}
                    onChange={onServiceProviderChanged}
                  />
                </Form.Item>
              </Col>
            )}
  
            <Col span={12}>
              <Form.Item
                    label={
                      <RequiredLabel
                        text={t("Modules.Appointments.charges")}
                        required={true}
                      />
                    }
                    name="service_price"
                    rules={[
                      {
                        required: true,
                        message: t("Modules.Appointments.pleaseEnterCharges"),
                      },
                      {
                        validator: (_, value) => {
                          if (value && value < 1)
                            return Promise.reject(
                              `${t("Modules.Appointments.charges")} ${t(
                                "CommonUtils.shouldBeGreaterThan0"
                              )}`
                            );
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      placeholder={t(
                        "Modules.Appointments.enterCharges"
                      )}
                      onKeyDown={(e) => allowCharactersOnlyForDecimalNumbers(e)}
                    />
                  </Form.Item>
            </Col>
  
            <Col span={24}>
              <Flex gap="1rem" align="center" justify="center">
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  disabled={loading}
                >
                  {t("CommonUtils.add")}
                </Button>
              </Flex>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };
  
  export default ServiceInfoFormDialog;
  